import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from "@mui/material";
import formatDate from "../../../unit/formatDate";
import HeaderLabelGridField from "../../../unit/HeaderLabelGridField";
import HeaderLabelTitle from "../../../unit/HeaderLabelTitle";
import HeaderLabelValue from "../../../unit/HeaderLabelValue";

const Notices = ({ sourcedata }: any) => {
  if (!sourcedata) {
    return <>Loading...</>;
  }
  const fileSummary = sourcedata.fileSummary;
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <HeaderLabelTitle title="Notices" suffix="" />
      </AccordionSummary>
      <AccordionDetails>
        <Grid container rowSpacing={1} columnSpacing={1}>
          <HeaderLabelGridField
            title="Report At"
            value={
              sourcedata.trackingDate ? formatDate(sourcedata.trackingDate) : ""
            }
            dxs={10}
            tdxs={2}
            fontFamily="numberFontFamily"
          />
          <HeaderLabelGridField
            title="Credit Data Since"
            value={
              fileSummary.inFileSinceDate
                ? formatDate(fileSummary.inFileSinceDate.content)
                : ""
            }
            dxs={10}
            tdxs={2}
            fontFamily="numberFontFamily"
          />
          <HeaderLabelGridField
            title="SSN match"
            value={fileSummary.ssnMatchIndicator}
            dxs={10}
            tdxs={2}
            fontFamily="numberFontFamily"
          />

          <Grid item xs={2} display="flex" gap={1}>
            <HeaderLabelTitle title="Credit Data Status" />
          </Grid>
          <Grid item xs={10} display="flex" gap={1}>
            {fileSummary.creditDataStatus ? (
              <>
                <Typography variant="body2" color="black">
                  Suppressed ({fileSummary.creditDataStatus.suppressed})
                </Typography>
                <Typography variant="body2" color="black">
                  Minor ({fileSummary.creditDataStatus.minor})
                </Typography>
                <Typography variant="body2" color="black">
                  Disputed ({fileSummary.creditDataStatus.disputed})
                </Typography>
              </>
            ) : (
              <HeaderLabelValue value="No Data" />
            )}
          </Grid>

          <HeaderLabelGridField
            title="Consumer Statement"
            value={fileSummary.consumerStatementIndicator}
            dxs={10}
            tdxs={2}
          />
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default Notices;
